<script>
export default {
  props: {
    countryId: {
      required: true,
      type: Number,
      default: 233
    }
  },

  data() {
    return {
      currentCountry: this.countryId,
      statesOptions: null,
      statesArray: window.__ADDRESSFORM__.statesArray || [],
      shipToStates: window.__ADDRESSFORM__.shipToStates || []
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/AddressForm.vue